import React, { Component, ErrorInfo, ReactNode } from 'react'
import * as Sentry from '@sentry/react'
import { sentryEnchancedMessage } from '../../../utils/runtimeReporters'

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(_: Error): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Uncaught error:', error, info)
    sentryEnchancedMessage({
      level: Sentry.Severity.Error,
      tag: 'ERROR BOUNDARY',
      user: {},
      payload: { error, info },
      message: 'ErrorBoundary component',
    })
  }

  public render() {
    const {
      state,
      props,
    } = this

    // eslint-disable-next-line no-constant-condition
    if (state.hasError && false) {
      return <h1>Sorry.. there was an error</h1>
    }

    return props.children
  }
}

export default ErrorBoundary
